module.exports = __webpack_public_path__ + "img/icon_sports.24ba8cb.svg";